<template>
    <b-modal v-model="modalShow" centered   id="modalPassport" hide-footer>
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-body modalPassport">
                    <section class="passport-info">
                        <h1 class="passport-info__title">паспорт модели</h1>
                        <h2 class="passport-info__subtitle">{{product.name}}</h2>
                        <h3 class="grey-title" v-if="product.prop.placeOfApplication.length != 0">Место применения</h3>
                        <div class="passport-info__options-block" v-if="product.prop.placeOfApplication.length != 0">
                            <div class="passport-info__option">
                                <p 
                                    v-for="(item, index) in product.prop.placeOfApplication" :key="index">
                                    {{item}}
                                </p>
                            </div>
                        </div>
                        <h3 class="grey-title" v-if="product.prop.trustPoint != 0">Точка доверия</h3>
                        <div class="passport-info__options-block" v-if="product.prop.trustPoint != 0">
                            <p class="passport-info__option" v-html="product.prop.trustPoint"></p>
                        </div>
                        
                        <h3 class="grey-title" v-if="product.prop.photoHistory.length != 0">Фото аналога / история</h3>
                        <div class="passport-info__options-block" v-if="product.prop.photoHistory.length != 0">
                            <slick 
                                class="history-slider"
                                :options="sliderOptions">
                                <div 
                                    class="history-slider__item"
                                    v-for="(item, index) in product.prop.photoHistory" :key="index">
                                    <a href="" v-on:click.prevent.stop :style="{ backgroundImage: 'url('+ item +')' }"></a>
                                </div>
                            </slick>
                        </div>
                        <h3 class="grey-title" v-if="product.prop.typeOfMount">Тип крепления</h3>
                        <div class="passport-info__options-block" v-if="product.prop.typeOfMount">
                            <p 
                                class="passport-info__option"
                                v-for="(item, index) in product.prop.typeOfMount" :key="index">
                                 - {{item}}
                            </p>
                        </div>
                        <h3 class="grey-title" v-if="product.offers">К этому товару подходят</h3>
                        <div class="passport-info__options-block recomended-block">
                            <div class="chess">
                                <a href="" v-on:click.prevent.stop class="chess__item" v-for="(item, index) in product.prop.recommendations" :key="index">
                                    <div 
                                        class="chess__img" 
                                        :style="{ backgroundImage: 'url('+ item.picture +')' }"></div>
                                    <p class="chess__discription">
                                        {{item.name}}
                                    </p>
                                </a>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </b-modal>
</template>
<script>
import Slick from 'vue-slick';
export default {
    components: { Slick },
    props: [
        "product"
    ],
    data: () => ({
        modalShow: false,
        trustPoint: [],
        sliderOptions: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            centerMode: true,
            infinite: false,
            variableWidth: true
        }
    })
}
</script>
<style lang="scss" scoped>
.modal-content{
    max-height: 90vh ;
    border: none;
}
.passport-info__options-block{
    padding-left: 10px;
    padding-right: 10px;
}
.chess{
    width: 100%;
}
.chess__num{
    display: flex;
}
</style>